import script from "./AppAlert.vue?vue&type=script&setup=true&lang=js"
export * from "./AppAlert.vue?vue&type=script&setup=true&lang=js"

import "./AppAlert.vue?vue&type=style&index=0&id=374de466&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-374de466"]])

export default __exports__